import { render } from "./customcolor.vue?vue&type=template&id=afa5ccfa"
import script from "./customcolor.vue?vue&type=script&lang=js"
export * from "./customcolor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__